import { AbstractControl, FormArray, FormGroup } from '@angular/forms';
import { addRemoveError, getControl } from '@shared/helpers/form.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { isEqual } from 'lodash-es';
import { NOT_VALID, REQUIRED_STATUS } from '@shared/constants/shared.constants';
import CodiceFiscale from 'codice-fiscale-js';
import { onlyConsonantRegex, onlyVowelsRegex } from '@shared/constants/regex.const';
import { isAfter } from 'date-fns';
import { CaricaCode } from '../consts/carica-code.const';

export const formArrayRequiredHelper = (formArray: FormArray, targetPath: string, suppCondition = true) => {
    formArray?.controls?.forEach((group: FormGroup) => {
        const targetControl = getControl(group, targetPath);
        const errors = targetControl.errors ? targetControl.errors : {};

        addRemoveError(suppCondition && isNilOrEmpty(targetControl?.value), errors, targetPath, {
            status: REQUIRED_STATUS,
        });

        targetControl.setErrors(isEqual(errors, {}) ? null : errors);
    });
};

export const validaCodiceFiscale = (nomeUtente: string, cognomeUtente: string, codiceFiscaleControl: AbstractControl) => {
    const errors = codiceFiscaleControl.errors ?? {};
    const rawCf = String(codiceFiscaleControl.value ?? '');

    if (!nomeUtente || !cognomeUtente || !rawCf) {
        codiceFiscaleControl.setErrors(isEqual(errors, {}) ? null : errors);
        return;
    }

    const cfUpper = rawCf.toUpperCase();
    const cfPrefix6 = cfUpper.slice(0, 6);
    const consonantiNome = nomeUtente.replace(onlyConsonantRegex, '');
    const consonantiCognome = cognomeUtente.replace(onlyConsonantRegex, '');
    const vocaliNome = nomeUtente.replace(onlyVowelsRegex, '');
    const vocaliCognome = cognomeUtente.replace(onlyVowelsRegex, '');

    const generatedCognome = (consonantiCognome + vocaliCognome + 'XXX').slice(0, 3);

    let generatedNome: string;
    if (consonantiNome.length >= 4) {
        generatedNome = `${consonantiNome[0] ?? ''}${consonantiNome[2] ?? ''}${consonantiNome[3] ?? ''}`;
    } else {
        generatedNome = (consonantiNome + vocaliNome + 'XXX').slice(0, 3);
    }

    const nomeCognome = (generatedCognome + generatedNome).toUpperCase();
    const cfIsValid = CodiceFiscale.check(rawCf) === true;

    addRemoveError(!cfIsValid, errors, 'errore', {
        status: NOT_VALID,
        message: "Errore sull'ultimo carattere del Codice fiscale",
    });

    addRemoveError(nomeCognome !== cfPrefix6, errors, 'errore', {
        status: NOT_VALID,
        message: 'Il nome ed il cognome non corrispondono ai valori inseriti nel Codice fiscale',
    });

    codiceFiscaleControl.setErrors(isEqual(errors, {}) ? null : errors);
};

export const controlloCaricaPresidente = (formArray: FormArray, fieldName: string) => {
    const controls = formArray?.controls ?? [];
    let presidenti = 0;

    for (let i = 0; i < controls.length; i++) {
        const group = controls[i] as FormGroup;
        const v = getControl(group, fieldName).value;
        if (v === CaricaCode.PRESIDENTE) {
            presidenti++;
        }
    }

    const hasMultiplePresidenti = presidenti >= 2;

    for (let i = 0; i < controls.length; i++) {
        const group = controls[i] as FormGroup;
        const fieldControl = getControl(group, fieldName);
        const value = fieldControl.value;
        const errors = fieldControl.errors ?? {};

        addRemoveError(isNilOrEmpty(value), errors, fieldName, {
            status: REQUIRED_STATUS,
        });

        addRemoveError(hasMultiplePresidenti && value === CaricaCode.PRESIDENTE, errors, fieldName, {
            status: 'Più presidenti',
            message: 'È consentito un solo Presidente',
        });

        fieldControl.setErrors(isEqual(errors, {}) ? null : errors);
    }
};

export const checkDataFutura = (dataElezione: string): boolean => {
    const data = new Date(dataElezione);
    return isAfter(data, new Date());
};
